import { AttendanceDayView, mapAttendanceDayViews } from "./AttendanceDayView";
import { AttendanceSiteView, mapAttendanceSiteViews } from "./AttendanceSiteView";
import { AttendanceStaffView, mapAttendanceStaffViews } from "./AttendanceStaffView";

/* ******************************************************* Attendance */
export interface Attendance {
    day_view?: AttendanceDayView[];
    site_view?: AttendanceSiteView[];
    staff_view?: AttendanceStaffView[];
}

export const mapAttendance = (data: any): Attendance => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: Attendance = {
        day_view: Array.isArray(data.day_view) ? mapAttendanceDayViews(data.day_view) : [],
        site_view: Array.isArray(data.site_view) ? mapAttendanceSiteViews(data.site_view) : [],
        staff_view: Array.isArray(data.staff_view) ? mapAttendanceStaffViews(data.staff_view) : [],
    }

    return response;
}

export const mapAttendances = (data: any[]): Attendance[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapAttendance);
}
/* ******************************************************* */